import { Badge, Button, Group } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

export type CohortNoteKind = 'shared' | 'individual';

export function CohortProgressNoteTitleExtras({
  noteKind,
  sharedNoteHref,
}: {
  noteKind: CohortNoteKind;
  /** When viewing an individual fan-out copy, link back to the shared session note. */
  sharedNoteHref?: string;
}): JSX.Element {
  return (
    <Group gap="sm" align="center" wrap="wrap">
      <Badge
        color={noteKind === 'shared' ? 'teal' : 'blue'}
        variant="light"
        size="lg"
        leftSection={<IconUsers size={14} />}
        w="fit-content"
      >
        {noteKind === 'shared' ? 'Shared group note' : 'Individual patient note'}
      </Badge>
      {noteKind === 'individual' && sharedNoteHref ? (
        <Button
          component={Link}
          to={sharedNoteHref}
          variant="light"
          color="teal"
          size="sm"
          leftSection={<IconUsers size={14} />}
          data-testid="open-shared-group-note-link"
        >
          Open shared session note
        </Button>
      ) : null}
    </Group>
  );
}
